import Vue from 'vue'
import globalMixins from './js/global-mixins'

Vue.mixin(globalMixins)
Vue.use(require('vue-moment'))

export { globalMixins };
export { default as ActionsButton } from './components/buttons/ActionsButton.vue'
export { default as AnimatedIcon } from './components/icons/AnimatedIcon.vue'
export { default as Badge } from './components/texts/Badge.vue'
export { default as Block } from './components/blocks/Block.vue'
export { default as Card } from './components/blocks/Card.vue'
export { default as Checkbox } from './components/inputs/Checkbox.vue'
export { default as CircleIndicator } from './components/charts/CircleIndicator'
export { default as CommonTitle } from './components/texts/CommonTitle.vue'
export { default as ContentConfirm } from './components/modal/contentModal/ContentConfirm.vue'
export { default as CountryInput } from './components/inputs/CountryInput.vue'
export { default as DatePicker } from './components/inputs/DatePicker.vue'
export { default as Dots } from './components/slider/Dots.vue'
export { default as DropdownInput } from './components/inputs/DropdownInput.vue'
export { default as FeedbackBanner } from './components/texts/FeedbackBanner.vue'
export { default as FileInput } from './components/inputs/FileInput.vue'
export { default as Form } from './components/Form.vue'
export { default as GlobalLoader } from './components/transitions/GlobalLoader.vue'
export { default as HeaderModal } from './components/modal/HeaderModal.vue'
export { default as Help } from './components/Help.vue'
export { default as HorizontalSelector } from './components/inputs/HorizontalSelector.vue'
export { default as HrLine } from './components/blocks/HrLine.vue'
export { default as InputDropdown } from './components/inputs/InputDropdown.vue'
export { default as InputFieldWithLabel } from './components/inputs/InputFieldWithLabel.vue'
export { default as InputOptions } from './components/inputs/InputOptions.vue'
export { default as InputPhoneNumber } from './components/inputs/InputPhoneNumber.vue'
export { default as Layout } from './components/blocks/Layout.vue'
export { default as Loader } from './components/transitions/Loader.vue'
export { default as Message } from './components/texts/Message.vue'
export { default as Modal } from './components/modal/Modal.vue'
export { default as NumberInput } from './components/inputs/NumberInput.vue'
export { default as PhonenumberInput } from './components/inputs/PhonenumberInput.vue'
export { default as Price } from './components/formatters/Price.vue'
export { default as RadioButtonList } from './components/inputs/RadioButtonList.vue'
export { default as RoundedButton } from './components/buttons/RoundedButton.vue'
export { default as RouterTransition } from './components/transitions/RouterTransition.vue'
export { default as Section } from './components/blocks/Section.vue'
export { default as SectionTitle } from './components/texts/SectionTitle.vue'
export { default as Slider } from './components/slider/Slider.vue'
export { default as Spot } from './components/inputs/Spot.vue'
export { default as StateInput } from './components/inputs/StateInput.vue'
export { default as Step } from './components/blocks/Step.vue'
export { default as Steps } from './components/blocks/Steps.vue'
export { default as TextArea } from './components/inputs/TextArea.vue'
export { default as TitleText } from './components/texts/TitleText.vue'
export { default as ToggleSwitch } from './components/inputs/ToggleSwitch.vue'
export { default as Tooltip } from './components/texts/Tooltip.vue'
export { default as Transition } from './components/transitions/Transition.vue'
export { default as UploadZone } from './components/inputs/UploadZone.vue'

export { default as InformationIcon } from './assets/images/icons/information.svg'

export { validate as Validate } from './validators'
export { default as EmailFormatValidator } from './validators/emailFormat'
export { default as PasswordFormatValidator } from './validators/passwordFormat'
export { default as RequiredValidator } from './validators/required'
